/**
 * @file add-brand.tsx
 * @deprecated Copied to app/modules/procurement/pages/master/brands/add-brand.tsx. This file still serves the existing /UProcure routes.
 * @module app/modules/uProcure/master/brands
 * @description Component for adding new brands in the master section.
 *   Provides a form to input brand details, upload brand logo, and save the brand information.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 *
 * @todo Missing auditLogMessage: pass generateLogMessageForBrand via
 *   brandsJSON.addBrands({ brands, auditLogMessage }) — extend apiJSON/master.ts first.
 * @todo fetchBrands() is commented out in useEffect; CreatableSelectWhite options may be empty on load.
 * @todo Remove debug console.log calls (brand, validation, selectedOption, inputValue, newValue).
 * @todo Remove duplicate h1 when PageTitle is used on the route wrapper.
 * @todo Remove unused axios import if not used elsewhere in this file.
 */

import clsx from "clsx";
import React, { FC, useEffect, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import UploadImage from "../.../../../../../../_admin/assets/media/svg_uTrade/add-img.svg";
import { success } from "../../../../../Global/toast";
import cross from "../../../../../_admin/assets/media/svg_uTrade/cross-red.svg";
import Close from "../../../../../_admin/assets/media/svg_uTrade/cross-rounded-gray.svg";
import APICallService from "../../../../../api/apiCallService";
import { master } from "../../../../../api/apiEndPoints";
import { brandsJSON } from "../../../../../api/apiJSON/master";
import { masterToast } from "../../../../../utils/toast";
import { Add, Brand } from "../../../../../utils/constants";
import Method from "../../../../../utils/methods";
import { fileValidation } from "../../../../../Global/fileValidation";
import { useDebounce } from "../../../../../utils/useDebounce";
import { useAuth } from "../../../auth";
// import { warehouse as warehouseStoreString } from '../../../../utils/storeString';
// import { getKey } from '../../../../Global/history';
import { CreatableSelectWhite } from "../../../../custom/Select/CreatableSelectWhite";
import axios from "axios";
import { useWarehouse } from "../../../../context/WarehouseContext";
const AddBrand: FC = () => {
  const { selectedWarehouse } = useWarehouse();
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [brandData, setBrandData] = useState([]);
  const [brand, setBrand] = useState<
    {
      brandName: string;
      brandImage: string;
      brandImageReader: any;
    }[]
  >([
    {
      brandName: "",
      brandImage: "",
      brandImageReader: "",
    },
  ]);
  const [validation, setValidation] = useState<
    {
      brandName: boolean;
      brandImage: boolean;
    }[]
  >([
    {
      brandName: false,
      brandImage: false,
    },
  ]);
  useEffect(() => {
    (async () => {
      if (!Method.hasPermission(Brand, Add, currentUser)) {
        return window.history.back();
      }
    })();
    // fetchBrands()
  }, []);
  const handleAddMore = () => {
    if (!loading) {
      let tempInputValue = [...inputValue];
      let temp = [...brand];
      let validateTemp = [...validation];
      let length = temp.length - 1;
      if (!temp[length].brandName && !temp[length].brandImage) {
        validateTemp[length].brandName = true;
        validateTemp[length].brandImage = true;
      } else if (!temp[length].brandName) {
        validateTemp[length].brandName = true;
      } else if (!temp[length].brandImage) {
        validateTemp[length].brandImage = true;
      } else {
        const allTrue = validateTemp.every(
          (obj) => obj.brandName === false && obj.brandImage === false,
        );
        if (allTrue) {
          validateTemp.push({
            brandName: false,
            brandImage: false,
          });
          temp.push({
            brandName: "",
            brandImage: "",
            brandImageReader: "",
          });
          inputValue.push("");
          setBrand(temp);
          setInputValue(tempInputValue);
        }
      }
      setValidation(validateTemp);
    }
  };
  const handleRemove = async (e: any, index: any) => {
    let temp = [...brand];
    let tempInputValue = [...inputValue];
    let validateTemp = [...validation];
    validateTemp.splice(index, 1);
    temp.splice(index, 1);
    tempInputValue.splice(index, 1);
    setValidation(validateTemp);
    setBrand(temp);
    setInputValue(tempInputValue);
  };
  const handleCategoryName = (value: any, index: any) => {
    let temp = [...brand];
    let validateTemp = [...validation];
    temp[index].brandName = value.trimStart();
    if (value.trimStart().length > 0) {
      validateTemp[index].brandName = false;
    } else {
      validateTemp[index].brandName = true;
    }
    setBrand(temp);
    setValidation(validateTemp);
  };
  const handleImageChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: any,
  ) => {
    const selectedFiles = event.target.files;
    let temp = [...brand];
    let validateTemp = [...validation];
    if (!selectedFiles || selectedFiles.length === 0) return;
    if (fileValidation(selectedFiles[0])) {
      validateTemp[index].brandImage = false;
      temp[index].brandImage = URL.createObjectURL(selectedFiles[0]);
      temp[index].brandImageReader = selectedFiles[0];
      setBrand(temp);
    } else {
      event.target.value = "";
    }
    setValidation(validateTemp);
  };
  const handleImageDiscard = (index: any) => {
    let temp = [...brand];
    let validateTemp = [...validation];
    validateTemp[index].brandImage = true;
    temp[index].brandImage = "";
    temp[index].brandImageReader = {};
    setBrand(temp);
    setValidation(validateTemp);
  };
  const handleSaveCategory = async () => {
    let temp = [...brand];
    let validateTemp = [...validation];
    let length = temp.length - 1;
    if (!temp[length].brandName && !temp[length].brandImage) {
      validateTemp[length].brandName = true;
      validateTemp[length].brandImage = true;
    } else if (!temp[length].brandName) {
      validateTemp[length].brandName = true;
    } else if (!temp[length].brandImage) {
      validateTemp[length].brandImage = true;
    } else {
      const allTrue = validateTemp.every(
        (obj) => obj.brandName === false && obj.brandImage === false,
      );
      if (allTrue) {
        setLoading(true);
        let apiService = new APICallService(
          master.addBrands,
          brandsJSON.addBrands({ brands: brand }),
          "",
          "",
          "",
          "",
          Brand,
          selectedWarehouse?.value || null,
        );
        let response = await apiService.callAPI();
        if (response) {
          navigate("/UProcure/master/brands");
          success(masterToast.addbrand);
        }
      }
    }
    setValidation(validateTemp);
    setLoading(false);
  };
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState<Array<string>>([""]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [searchValue, setSearchValue] = useState<any>("");
  const fetchBrands = async (searchText = "") => {
    setLoading(true);
    let params: any = {
      sortKey: "title",
      sortOrder: 1,
      searchTerm: searchText,
    };
    let apiService = new APICallService(
      master.listBrands,
      brandsJSON.listBrands(params),
      "",
      "",
      "",
      "",
      Brand,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response.records) {
      const formattedOptions = response.records.map((brand: any) => ({
        value: brand._id,
        label: brand.title,
      }));
      setOptions(formattedOptions);
    } else {
      setOptions([]);
    }
    setLoading(false);
  };
  const debounce = useDebounce(fetchBrands, 500);
  const handleInputChange = (value: any, index: any) => {
    setInputValue((pre) => {
      const temp = [...pre];
      temp[index] = value;
      return temp;
    });
    if (value.length > 0) {
      debounce(value);
      setBrand((prevState) => {
        const updatedBrand = [...prevState];
        updatedBrand[index].brandName = value.trimStart();
        return updatedBrand;
      });
      setValidation((prevState) => {
        const updatedValidation = [...prevState];
        updatedValidation[index].brandName = value.trim().length === 0;
        return updatedValidation;
      });
    } else {
      setOptions([]);
    }
  };
  const handleBlur = (index: any) => {
    setValidation((prevState) => {
      const updatedValidation = [...prevState];
      updatedValidation[index].brandName =
        brand[index].brandName.trim().length === 0;
      return updatedValidation;
    });
  };
  const handleChange = (newValue: any, index: number) => {
    console.log("newValue", newValue);
    let tempBrand = [...brand];
    let tempValidation = [...validation];

    if (newValue) {
      if (newValue.__isNew__) {
        tempBrand[index].brandName = newValue.label.trimStart();
        tempValidation[index].brandName = false;
        console.log("New option created:", newValue.label);
      } else {
        tempBrand[index].brandName = newValue.label.trimStart();
        tempValidation[index].brandName = false;
      }
    } else {
      tempBrand[index].brandName = "";
      tempValidation[index].brandName = true;
    }
    setBrand(tempBrand);
    setValidation(tempValidation);
  };

  return (
    <>
      <div className="p-5">
        <Row className="g-6">
          <Col xs={12}>
            <h1 className="fs-22 fw-bolder mb-0">Add brand</h1>
          </Col>
          {brand.map((val, index) => {
            return (
              <>
                <Col xs={12}>
                  <Card className="bg-light border">
                    <Card.Body className="p-5">
                      <Row>
                        <Col lg={6} className="mb-6">
                          <Row className="align-items-center">
                            <Col lg={4}>
                              <label className="fs-16 fw-500 text-dark mb-lg-0 mb-3">
                                Brand name
                              </label>
                            </Col>
                            <Col lg={8}>
                              {/* <input
                                type="text"
                                className={clsx(
                                  'form-control form-control-solid bg-white h-60px border form-control-lg text-dark fs-16 fw-600',
                                  validation[index].brandName
                                    ? 'border-danger'
                                    : ''
                                )}
                                name="name"
                                placeholder="Type here…"
                                value={val.brandName}
                                disabled={loading}
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ): void =>
                                  handleCategoryName(e.target.value, index)
                                }
                              /> */}
                              <CreatableSelectWhite
                                isClearable
                                isMulti={false}
                                options={options}
                                value={
                                  options.find(
                                    (option: any) =>
                                      option.label === brand[index].brandName,
                                  ) ||
                                  (brand[index].brandName
                                    ? {
                                        label: brand[index].brandName,
                                        value: brand[index].brandName,
                                      }
                                    : null)
                                }
                                onChange={(newValue: any) =>
                                  handleChange(newValue, index)
                                }
                                inputValue={inputValue[index]}
                                onInputChange={(value: any) =>
                                  handleInputChange(value, index)
                                }
                                placeholder="Type to search or create..."
                                isLoading={loading}
                                onBlur={() => handleBlur(index)}
                                noOptionsMessage={() =>
                                  inputValue
                                    ? "No options found, press enter to create."
                                    : "Start typing..."
                                }
                                border={clsx(
                                  validation[index].brandName ? "#e55451" : "",
                                )}
                              />
                              <div className="fv-plugins-message-container">
                                <span className="text-danger fs-12 fw-bold">
                                  {validation[index].brandName
                                    ? "Please enter brand name"
                                    : ""}
                                </span>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      {brand.length === 1 ? (
                        <></>
                      ) : !loading ? (
                        <div className="group-categories-cross">
                          <img
                            src={cross}
                            height={16}
                            width={16}
                            onClick={(e) => {
                              handleRemove(e, index);
                            }}
                            alt=""
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                      <Row>
                        <Col lg={2}>
                          <label className="fs-16 fw-500 text-dark mb-lg-0 mb-3 mt-lg-3">
                            Upload <br />
                            brand logo
                          </label>
                        </Col>
                        <Col lg={10} className="d-flex">
                          <div className="d-flex flex-column">
                            <div className="upload-btn-wrapper">
                              <div className="symbol symbol-160px symbol-md-170px">
                                <img
                                  className={clsx(
                                    "border border-r10px bg-white object-fit-contain",
                                    validation[index].brandImage
                                      ? "border-danger"
                                      : "border",
                                  )}
                                  src={
                                    val.brandImage
                                      ? val.brandImage
                                      : UploadImage
                                  }
                                  alt=""
                                />
                              </div>
                              <input
                                className="w-100 h-100"
                                type="file"
                                name="myfile"
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ): void => handleImageChange(e, index)}
                              />
                              <div className="fv-plugins-message-container">
                                <span className="text-danger fs-12 fw-bold">
                                  {validation[index].brandImage
                                    ? "Please upload brand logo"
                                    : ""}
                                </span>
                              </div>
                            </div>
                            <span className="text-gray text-italic">{`Image dimensions:-(700x700px)`}</span>
                          </div>
                          {val.brandImage && !loading ? (
                            <label
                              className="btn btn-icon btn-circle btn-active-color-primary w-50px h-50px responsive-closed"
                              data-kt-image-input-action="change"
                              title=""
                            >
                              <img
                                src={Close}
                                onClick={(): void => handleImageDiscard(index)}
                                className="responsive-closed-icon-closed"
                                alt=""
                                height={33}
                                width={33}
                              />
                            </label>
                          ) : (
                            <></>
                          )}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </>
            );
          })}
          <div className="d-flex flex-column">
            <Link
              to="#"
              className="text-primary fs-16 fw-bolder"
              onClick={handleAddMore}
            >
              + Add new brand
            </Link>
            <Row className="align-items-center mt-6 g-3">
              <Col xs="auto">
                <Button
                  variant="danger"
                  size="lg"
                  className="uw-btn uw-btn-danger uw-btn-lg btn-active-danger"
                  onClick={() => navigate("/UProcure/master/brands")}
                >
                  Cancel
                </Button>
              </Col>
              <Col xs="auto">
                <Button className="uw-btn uw-btn-primary uw-btn-lg"
                  variant="primary"
                  size="lg"
                  onClick={handleSaveCategory}
                  disabled={loading}
                >
                  {!loading && (
                    <span className="indicator-label">Save brand</span>
                  )}
                  {loading && (
                    <span
                      className="indicator-progress"
                      style={{ display: "block" }}
                    >
                      Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
                </Button>
              </Col>
            </Row>
          </div>
        </Row>
      </div>
    </>
  );
};
export default AddBrand;
